"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstNameValidationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@framework/constants");
exports.firstNameValidationSchema = (0, yup_1.string)()
    .min(constants_1.firstNameMinLength, "form.validations.tooShort")
    .max(constants_1.firstNameMaxLength, "form.validations.tooLong")
    .required("form.validations.valueMissing");
//# sourceMappingURL=first-name.js.map